




import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconCopy extends Vue {
    @Prop({ type: Number, default: 28 }) readonly size!: number

}
